import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "fileConstructionContentCommonDirList" }
const _hoisted_2 = { class: "commonDirList" }

import { CommonDirEntity, CommonDirMap, ExtraDirMap } from '@/api/fileConstruction';
import { computed, onMounted, ref } from 'vue';
import {
    FileConstructionActions,
    FileConstructionGetters,
    FileConstructionMutations,
} from "@/store/modules/fileConstruction";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { FileConstructionNode, DisplayTypeEnum } from '@/store/modules/fileConstruction/types';
import { ElTable } from 'element-plus'


import { defineComponent } from "vue";

const __default__ = defineComponent({
    name: "FileConstructionContentCommonDirList",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const extraDir = ref<typeof ElTable | null>(null);
const isOfficeExpand = ref<boolean>(false)
const getRowClassName = (row: any): string => {
    if (row.row.children === undefined) {
        return 'hide-expand'
    }
    return '';
}

const handleDetail = (row: any) => {
    if (row.name === 'Office文档') {
        if (extraDir.value !== null) {
            isOfficeExpand.value = !isOfficeExpand.value
        }
    }
    if (extraDir.value !== null) {
        if (!row.children) {
            extraDir.value.toggleRowExpansion(row, false)
        }
    }
}

const store = useStore();
const route = useRoute();
const projectId = computed(() => typeof (route.params.projId) === "string" ?
    route.params.projId : route.params.projId[0]);
const targetId = computed(() => typeof (route.params.targetId) === "string" ?
    route.params.targetId : route.params.targetId[0]);

const username = computed(() => {
    return store.getters[`fileConstruction/${FileConstructionGetters.GetUserName}`];
});
const diskSlice = computed(() => {
    return store.getters[`fileConstruction/${FileConstructionGetters.getDiskSlice}`];
});

const isUsernameLoading = computed(() => {
    return store.getters[`fileConstruction/${FileConstructionGetters.getIsUserNameLoading}`];
});

const isLoading = computed(() => {
    return store.getters[`fileConstruction/${FileConstructionGetters.getLoading}`];
});
const currentPath = computed(() => {
    return store.getters[`fileConstruction/${FileConstructionGetters.getCurrentPath}`];
});

const resetDigest = () => {
    try {
        store.commit(`fileConstruction/${FileConstructionMutations.setCurrentDigest}`, undefined);
    } catch (err) {
        console.log(err);
    }
}

const handleRowClick = (row: CommonDirEntity) => {
    if (isLoading.value) {
        return
    }
    resetDigest();
    try {
        const dir = row.dirStr.replace(/USERNAME/g, username.value);
        store.commit(`fileConstruction/${FileConstructionMutations.pushBackHistory}`, currentPath.value);
        store.dispatch(
            `fileConstruction/${FileConstructionActions.asyncGetChildrenByPath}`,
            { projId: projectId.value, filePath: dir, uid: targetId.value }
        );
        store.commit(`fileConstruction/${FileConstructionMutations.cleanForwardHistory}`);
    } catch (err) {
        store.commit(`fileConstruction/${FileConstructionMutations.popBackHistory}`);
        console.log(err);
    }
}

const handleRowClickForDisk = (row: FileConstructionNode): void => {
    if (isLoading.value) {
        return
    }
    resetDigest();
    const filePath = row.full_path + '/';
    try {
        store.commit(`fileConstruction/${FileConstructionMutations.pushBackHistory}`, currentPath.value);
        store.dispatch(
            `fileConstruction/${FileConstructionActions.asyncGetChildrenByPath}`,
            { projId: projectId.value, filePath: filePath, uid: targetId.value },
        );
        store.commit(`fileConstruction/${FileConstructionMutations.cleanForwardHistory}`);
    } catch (err) {
        store.commit(`fileConstruction/${FileConstructionMutations.popBackHistory}`);
        console.log(err);
    }
}


const handleGetDownloadList = (row: CommonDirEntity) => {
    resetDigest();
    if (row.name === '可下载') {
        try {
            if (currentPath.value !== 'downloaded') {
                store.commit(`fileConstruction/${FileConstructionMutations.pushBackHistory}`, currentPath.value);
            }
            store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetDownloadedFiles}`,
                { projId: projectId.value, uid: targetId.value, isAppend: false },
            );
            store.commit(
                `fileConstruction/${FileConstructionMutations.setDisplayType}`,
                DisplayTypeEnum.Downloaded,
            );
            store.commit(`fileConstruction/${FileConstructionMutations.cleanForwardHistory}`);
        } catch (err) {
            store.commit(`fileConstruction/${FileConstructionMutations.popBackHistory}`);
            console.log(err);
        }
    } else if (row.name === "已上传") {
        try {
            if (currentPath.value !== 'uploaded') {
                store.commit(`fileConstruction/${FileConstructionMutations.pushBackHistory}`, currentPath.value);
            }
            store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetUploadedFiles}`,
                { projId: projectId.value, uid: targetId.value, isAppend: false },
            );
            store.commit(`fileConstruction/${FileConstructionMutations.setDisplayType}`, DisplayTypeEnum.Uploaded)
            store.commit(`fileConstruction/${FileConstructionMutations.cleanForwardHistory}`);
        } catch (err) {
            store.commit(`fileConstruction/${FileConstructionMutations.popBackHistory}`);
            console.log(err);
        }
    } else if (row.name !== "Office文档") {
        try {
            store.commit(`fileConstruction/${FileConstructionMutations.pushBackHistory}`, currentPath.value);
            store.commit(`fileConstruction/${FileConstructionMutations.setDisplayType}`, DisplayTypeEnum.Extension)
            store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetExtensionFiles}`,
                { projId: projectId.value, uid: targetId.value, extension: row.name, isAppend: true },
            )
            store.commit(`fileConstruction/${FileConstructionMutations.cleanForwardHistory}`);
        } catch (err) {
            store.commit(`fileConstruction/${FileConstructionMutations.popBackHistory}`);
            console.log(err);
        }
    } else if (row.name === "Office文档") {
        if (extraDir.value !== null) {
            extraDir.value.toggleRowExpansion(row, !isOfficeExpand.value)
        }
    } else {
        return
    }
}

onMounted(async () => {
    await store.dispatch(
        `fileConstruction/${FileConstructionActions.asyncGetDiskSlices}`,
        { projId: projectId.value, uid: targetId.value },
    );
    await store.dispatch(
        `fileConstruction/${FileConstructionActions.asyncGetUserNameByProjIdAndUid}`,
        { projId: projectId.value, uid: targetId.value },
    );

})


return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(username) === '')
        ? (_openBlock(), _createBlock(_unref(ElTable), {
            key: 0,
            data: _unref(CommonDirMap),
            "show-header": false,
            stripe: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, { prop: "name" })
            ]),
            _: 1
          }, 8, ["data"]))
        : (_openBlock(), _createBlock(_unref(ElTable), {
            key: 1,
            data: _unref(CommonDirMap),
            onRowClick: handleRowClick,
            "show-header": false,
            stripe: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, { prop: "name" })
            ]),
            _: 1
          }, 8, ["data"])),
      (_unref(diskSlice).length !== 0)
        ? (_openBlock(), _createBlock(_unref(ElTable), {
            key: 2,
            data: _unref(diskSlice),
            onRowClick: handleRowClickForDisk,
            "show-header": false,
            stripe: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, { prop: "name" })
            ]),
            _: 1
          }, 8, ["data"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(ElTable), {
      class: "extraDirList",
      ref_key: "extraDir",
      ref: extraDir,
      data: _unref(ExtraDirMap),
      "show-header": false,
      onRowClick: handleGetDownloadList,
      "row-class-name": getRowClassName,
      onExpandChange: handleDetail,
      stripe: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { prop: "name" }),
        _createVNode(_component_el_table_column, { type: "expand" }, {
          default: _withCtx((props) => [
            _createVNode(_unref(ElTable), {
              data: props.row.children,
              "show-header": false,
              onRowClick: handleGetDownloadList
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, { prop: "name" })
              ]),
              _: 2
            }, 1032, ["data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ])), [
    [_directive_loading, _unref(isUsernameLoading)]
  ])
}
}

})